import React, { useEffect, useState } from "react";
import { trackEvent } from "../lib/analytics";
import { useSignupBus } from "../lib/signupBus";

/**
 * Bottom-of-screen sticky CTA, mobile only.
 * - Hides when the #join section is visible (the user is already there).
 * - Hides permanently once the user signs up (broadcastSignup event).
 */
const StickyMobileCta = () => {
  const [hidden, setHidden] = useState(false);
  const [joinInView, setJoinInView] = useState(false);
  const [cookieAccepted, setCookieAccepted] = useState(
    () => typeof window !== "undefined" && !!localStorage.getItem("xandi_cookie_ok")
  );

  useSignupBus(() => setHidden(true));

  useEffect(() => {
    const onAccept = () => setCookieAccepted(true);
    window.addEventListener("xandi:cookies-accepted", onAccept);
    return () => window.removeEventListener("xandi:cookies-accepted", onAccept);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("xandi_signed_up")) {
      setHidden(true);
      return;
    }
    const el = document.getElementById("join");
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => setJoinInView(entry.isIntersecting),
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // Suppress while cookie banner is still on-screen to prevent bottom-of-viewport overlap on mobile.
  if (hidden || joinInView || !cookieAccepted) return null;

  return (
    <a
      href="#join"
      className="sticky-cta"
      data-testid="sticky-mobile-cta"
      onClick={() => trackEvent("Sticky CTA Clicked")}
    >
      <span className="sticky-cta-dot" />
      <span className="sticky-cta-text">
        <strong>Get WELCOME15</strong>
        <small>15% off your first booking</small>
      </span>
      <span className="sticky-cta-go">Join →</span>
    </a>
  );
};

export default StickyMobileCta;
